export default "__VITE_ASSET__nrtzxI1$__"